/* R61: don't build the hidden legacy catalogue behind the active search view. */
(function(){
 function run(){
/* Coincidencias: mismas reglas tolerantes del buscador existente, sin otra lista. */
window.VelantisBusqueda=window.VelantisBusqueda||(function(){
 function norm(s){return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');}
 function distance(a,b){var d=[],i,j;for(i=0;i<=a.length;i++)d[i]=[i];for(j=1;j<=b.length;j++)d[0][j]=j;for(i=1;i<=a.length;i++)for(j=1;j<=b.length;j++){d[i][j]=Math.min(d[i-1][j]+1,d[i][j-1]+1,d[i-1][j-1]+(a[i-1]===b[j-1]?0:1));if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])d[i][j]=Math.min(d[i][j],d[i-2][j-2]+1);}return d[a.length][b.length];}
 function score(q,value){var n=norm(value);if(!q||!n)return 0;if(n===q)return 1000;if(n.indexOf(q)===0)return 900;if(n.indexOf(q)>=0)return 800;if(q.length<4)return 0;var max=Math.min(3,Math.floor(q.length*.28));if(Math.abs(n.length-q.length)>max)return 0;var d=distance(q,n);return d<=max?600-d*50:0;}
 function match(query,item){
  var q=norm(query),sku=norm(item.sku),name=item.nombre||'',house=item.casa||'',text=norm(item.texto||'');if(!q)return 0;
  if(/^v\d+$/.test(q)){q='v'+q.slice(1).padStart(3,'0');return sku===q?1100:sku.indexOf(q)===0?900:0;}
  var s=Math.max(score(q,name),Math.round(score(q,house)*.9));
  if(text.indexOf(q)>=0)s=Math.max(s,700);
  var words=String(query).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().split(/\s+/).map(norm).filter(Boolean);
  if(words.length>1&&words.every(function(w){return text.indexOf(w)>=0;}))s=Math.max(s,650);
  return s;
 }
 return {normalizar:norm,puntuar:score,coincidencia:match};
})();
window.VELANTIS_CASAS_COLECCIONES={"Abercrombie & Fitch":{"id":490093248736,"url":"/collections/abercrombie-fitch","handle":"abercrombie-fitch"},"Amouage":{"id":490094723296,"url":"/collections/amouage","handle":"amouage"},"Ariana Grande":{"id":490088759520,"url":"/collections/ariana-grande","handle":"ariana-grande"},"Armaf":{"id":490093314272,"url":"/collections/armaf","handle":"armaf"},"Azzaro":{"id":490088857824,"url":"/collections/azzaro","handle":"azzaro"},"BDK Parfums":{"id":490088431840,"url":"/collections/bdk-parfums","handle":"bdk-parfums"},"Bharara":{"id":490089971936,"url":"/collections/bharara","handle":"bharara"},"Bond No. 9":{"id":490083188960,"url":"/collections/bond-no-9","handle":"bond-no-9"},"Burberry":{"id":490090397920,"url":"/collections/burberry","handle":"burberry"},"BVLGARI":{"id":490090103008,"url":"/collections/bvlgari","handle":"bvlgari"},"Bvlgari":{"id":490090103008,"url":"/collections/bvlgari","handle":"bvlgari"},"Byredo":{"id":490083582176,"url":"/collections/byredo","handle":"byredo"},"Cacharel":{"id":490090463456,"url":"/collections/cacharel","handle":"cacharel"},"Carolina Herrera":{"id":490084073696,"url":"/collections/carolina-herrera","handle":"carolina-herrera"},"Casamorati":{"id":490093871328,"url":"/collections/casamorati","handle":"casamorati"},"Chanel":{"id":490086301920,"url":"/collections/chanel","handle":"chanel"},"Creed":{"id":488813297888,"url":"/collections/creed","handle":"creed"},"Dior":{"id":490086432992,"url":"/collections/dior","handle":"dior"},"Dolce&Gabbana":{"id":490090758368,"url":"/collections/dolce-gabbana","handle":"dolce-gabbana"},"Escentric Molecules":{"id":490088366304,"url":"/collections/escentric-molecules","handle":"escentric-molecules"},"Ferragamo":{"id":490090954976,"url":"/collections/ferragamo","handle":"ferragamo"},"Giardini di Toscana":{"id":490088562912,"url":"/collections/giardini-di-toscana","handle":"giardini-di-toscana"},"Giorgio Armani":{"id":490086531296,"url":"/collections/giorgio-armani","handle":"giorgio-armani"},"Givenchy":{"id":490091643104,"url":"/collections/givenchy","handle":"givenchy"},"Gucci":{"id":490086662368,"url":"/collections/gucci","handle":"gucci"},"Hermès":{"id":490373349600,"url":"/collections/hermes","handle":"hermes"},"Issey Miyake":{"id":490091970784,"url":"/collections/issey-miyake","handle":"issey-miyake"},"Jean Paul Gaultier":{"id":490086957280,"url":"/collections/jean-paul-gaultier","handle":"jean-paul-gaultier"},"Jo Malone London":{"id":490014671072,"url":"/collections/jo-malone","handle":"jo-malone"},"Juicy Couture":{"id":490092003552,"url":"/collections/juicy-couture","handle":"juicy-couture"},"Kayali":{"id":490083647712,"url":"/collections/kayali","handle":"kayali"},"Lancôme":{"id":490092200160,"url":"/collections/lancome","handle":"lancome"},"Lattafa Perfumes":{"id":490092364000,"url":"/collections/lattafa","handle":"lattafa"},"Le Labo":{"id":490014638304,"url":"/collections/le-labo","handle":"le-labo"},"Loewe":{"id":490093576416,"url":"/collections/loewe","handle":"loewe"},"Louis Vuitton":{"id":490014540000,"url":"/collections/louis-vuitton","handle":"louis-vuitton"},"Maison Crivelli":{"id":490088104160,"url":"/collections/maison-crivelli","handle":"maison-crivelli"},"Maison Francis Kurkdjian":{"id":490083320032,"url":"/collections/maison-francis-kurkdjian","handle":"maison-francis-kurkdjian"},"Maison Margiela":{"id":490093674720,"url":"/collections/maison-martin-margiela","handle":"maison-martin-margiela"},"Mancera":{"id":490083483872,"url":"/collections/mancera","handle":"mancera"},"Marc Jacobs":{"id":490092429536,"url":"/collections/marc-jacobs","handle":"marc-jacobs"},"Montale":{"id":490083516640,"url":"/collections/montale","handle":"montale"},"Montblanc":{"id":490092462304,"url":"/collections/montblanc","handle":"montblanc"},"Moschino":{"id":490092527840,"url":"/collections/moschino","handle":"moschino"},"Mugler":{"id":490087416032,"url":"/collections/mugler","handle":"mugler"},"Narciso Rodriguez":{"id":490092658912,"url":"/collections/narciso-rodriguez","handle":"narciso-rodriguez"},"Orto Parisi":{"id":490088628448,"url":"/collections/orto-parisi","handle":"orto-parisi"},"Parfums de Marly":{"id":490014736608,"url":"/collections/parfums-de-marly","handle":"parfums-de-marly"},"Prada":{"id":490087121120,"url":"/collections/prada","handle":"prada"},"Rabanne":{"id":490092822752,"url":"/collections/paco-rabanne","handle":"paco-rabanne"},"Ralph Lauren":{"id":490092921056,"url":"/collections/ralph-lauren","handle":"ralph-lauren"},"Room 1015":{"id":490093838560,"url":"/collections/room-1015","handle":"room-1015"},"Sol de Janeiro":{"id":490092953824,"url":"/collections/sol-de-janeiro","handle":"sol-de-janeiro"},"Thomas Kosmala":{"id":490093740256,"url":"/collections/thomas-kosmala","handle":"thomas-kosmala"},"Tom Ford":{"id":488813166816,"url":"/collections/tom-ford","handle":"tom-ford"},"Valentino":{"id":490083975392,"url":"/collections/valentino","handle":"valentino"},"Versace":{"id":490087284960,"url":"/collections/versace","handle":"versace"},"Viktor & Rolf":{"id":490093215968,"url":"/collections/viktor-rolf","handle":"viktor-rolf"},"Xerjoff":{"id":490083221728,"url":"/collections/xerjoff","handle":"xerjoff"},"Yves Saint Laurent":{"id":490085318880,"url":"/collections/yves-saint-laurent","handle":"yves-saint-laurent"}};
/* ===== VELANTIS · Catálogo por diseñador (10-sep-2026) =====
   Producción manda: las fragancias salen de window.VELANTIS_CAT y los precios del mapa
   vivo. Lo único propio de este archivo es cómo se agrupan y cómo se ven.

   Las fotos NO son archivos: la tarjeta se arma con el mismo marcado que usa el sitio
   —article.cat-card[data-name] con un div.cat-img dentro— y el puente del motor monta
   ahí su lienzo por su cuenta. Por lo mismo, el clic abre la ficha del sitio y el botón
   «Agregar» entra por el carrito del sitio, con sus promociones. */
(function(){
  var hueco = document.getElementById('ccx');
  if(!hueco) return;
  var DAT = null, CASAS = [], pintado = false, PRE = {}, ASOMO = 6;

  function json(id){ var n = document.getElementById(id); if(!n) return null;
    try{ return JSON.parse(n.textContent); }catch(e){ return null; } }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function plano(s){ return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function suave(s){ return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function cap(s){ s = String(s || '').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  function mapaVivo(){ return json('pc-conexion') || {}; }
  function precio(nom, t){
    var m = mapaVivo(), p = (t === '50' ? m.precios50 : m.precios) || {};
    var v = p[nom]; return v == null ? null : Math.round(v);
  }

  /* ------------------------------------------------------------ agrupar
     15-sep: además de los perfumes, los aromatizantes (ambientales) y los aceites para
     difusor. Cada uno va con la casa en la que se inspira, con la misma tabla que usa su
     página de producto; los de hoteles, tiendas y aromas propios van en las colecciones
     Luxury Hotels, Stores y Scents. Los aceites no viven en VELANTIS_CAT: vienen en
     cc-datos y solo entran si el mapa vivo tiene su variante de 100 ml, o sea, si se
     pueden cobrar. */
  function orden(x){ return x.ace ? 2 : (x.amb ? 1 : 0); }
  function agrupar(){
    var CAT = window.VELANTIS_CAT || [];
    if(!CAT.length) return false;
    var por = {}, vars = mapaVivo().variantes || {};
    CAT.forEach(function(r, i){
      var esAmb = r[1] === 'Ambiental' || r[9] === 'amb-0';
      var destino = esAmb ? (DAT.amb || {})[r[12]] : null;
      var casa = esAmb ? ((destino && destino.casa) || DAT.ambiental[r[0]]) : DAT.alias[plano(r[2] || '')];
      if(!esAmb)casa=window.VelantisProductCard.housesBySku[r[12]]||casa;
      if(!casa) return;                       /* los tres perfumes sin marca */
      (por[casa] = por[casa] || []).push({i:i, r:r, amb:esAmb, ref:(destino && destino.ref) || r[0]});
    });
    (DAT.aceites || []).forEach(function(a, k){
      if(!vars[a.n + ' · Aceite 100 ml']) return;
      var p = a.pyr || ['', '', ''];
      var r = [a.n, 'Aceite', '', 'Aceite para difusor', 'Aceites', p[0], p[1], p[2], '', 'amb-0', '', 450, a.sku];
      (por[a.casa] = por[a.casa] || []).push({i:'a' + k, r:r, ace:true, ref:a.ref || a.n, h:a.h});
    });
    CASAS = Object.keys(por).filter(function(casa){
      /* Las colecciones Luxury —hoteles, tiendas y aromas propios— no son casas
         perfumistas, así que no entran al catálogo por diseñador: salían entre
         dos firmas de verdad y ocupaban su letra en el riel A–Z. Sus productos
         siguen en el catálogo principal y en su apartado de aromatizantes. */
      return !(DAT.casas[casa] || {}).coleccion;
    }).map(function(casa){
      var lista = por[casa].sort(function(a, b){
        if(orden(a) !== orden(b)) return orden(a) - orden(b);   /* perfumes, aromatizantes, aceites */
        return String(a.r[0]).localeCompare(String(b.r[0]), 'es');
      });
      var ide = DAT.casas[casa] || {};
      if(ide.fuente !== 'casa'){
        var dom = {}, mejor = 'amaderados', top = 0;
        lista.forEach(function(x){ var k = x.r[9] === 'amb-0' ? 'limpios' : (x.r[9] || 'amaderados');
          dom[k] = (dom[k] || 0) + 1; if(dom[k] > top){ top = dom[k]; mejor = k; } });
        ide = Object.assign({}, DAT.porFamilia[mejor] || DAT.porFamilia.amaderados,
                            {id:ide.id, letra:ide.letra, origen:DAT.origenGenerico, fuente:'familia'});
      }
      var soloElla = lista.every(function(x){ return x.r[1] === 'Dama'; });
      return {casa:casa, ide:ide, lista:lista, soloElla:soloElla,
              color: (soloElla && ide.femenino) ? ide.femenino : ide.color};
    }).sort(function(a, b){
      var A = suave(a.casa).toUpperCase(), B = suave(b.casa).toUpperCase();
      return A < B ? -1 : A > B ? 1 : 0;
    });
    return CASAS.length > 0;
  }

  /* ------------------------------------------------------------ filtros
     Para ella / él / unisex y por tipo (15-sep). El filtro decide qué fichas tiene cada
     casa; el buscador trabaja encima de lo que el filtro deja. «Para» solo aplica a
     perfumes: un aromatizante o un aceite no tiene género, así que al elegir «Para ella»
     salen solo perfumes. */
  var FILTRO = {tipo:'', para:''};
  var PARA = {ella:'Dama', el:'Caballero', uni:'Unisex'};
  function pasa(x){
    // Una colección de género conserva su alcance aunque cambien los chips.
    var route=(location.hash.match(/^#\/([^/?]+)/)||[])[1];
    if(route==='disenadores'&&(x.amb||x.ace))return false;
    if(route==='ambientales'&&!x.amb)return false;
    if(route==='aceites'&&!x.ace)return false;
    if(route==='dama' && (x.amb || x.ace || ['Dama','Unisex'].indexOf(x.r[1])<0)) return false;
    if(route==='caballero' && (x.amb || x.ace || ['Caballero','Unisex'].indexOf(x.r[1])<0)) return false;
    if(route==='unisex' && (x.amb || x.ace || x.r[1]!=='Unisex')) return false;
    if(FILTRO.tipo === 'perf' && (x.amb || x.ace)) return false;
    if(FILTRO.tipo === 'amb' && !x.amb) return false;
    if(FILTRO.tipo === 'ace' && !x.ace) return false;
    if(FILTRO.para && (x.amb || x.ace || x.r[1] !== PARA[FILTRO.para])) return false;
    return true;
  }
  function hayFiltro(){ return !!(FILTRO.tipo || FILTRO.para); }
  function listaDe(c){ return hayFiltro() ? c.lista.filter(pasa) : c.lista; }
  function cuentaDe(lista){
    var p = 0, a = 0, o = 0;
    lista.forEach(function(x){ if(x.ace) o++; else if(x.amb) a++; else p++; });
    var t = [];
    if(p) t.push(p + (p === 1 ? ' fragancia' : ' fragancias'));
    if(a) t.push(a + (a === 1 ? ' aromatizante' : ' aromatizantes'));
    if(o) t.push(o + (o === 1 ? ' aceite para difusor' : ' aceites para difusor'));
    return t.join(' · ');
  }

  /* --------------------------------------------------- la tarjeta del sitio
     Marcado igual al de index-08 a proposito: con el mismo `data-name` y el mismo
     `div.cat-img` el motor monta su lienzo, el clic abre la ficha y el boton entra
     por el carrito. El precio es el del mapa vivo, no el congelado del catalogo. */
  function notas(r){
    var t = [r[5], r[6], r[7]].filter(Boolean).join(', ').replace(/\s*,\s*/g, ', ').trim();
    return cap(t.replace(/\.$/, ''));
  }
  function tarjeta(x,casa,femenino,soloElla){return window.VelantisProductCard.render(x,casa,femenino,soloElla,{mapa:mapaVivo(),preventa:PRE});}

  /* El sitio abre las tarjetas por nombre desde un escucha en `document` (fase de
     captura) y un aceite llamado «Aventus · Aceite 100 ml» no lo encuentra: caería en el
     perfume o en nada. Este escucha va en `window`, que corre antes, y lleva a la
     página de producto del aceite. El botón «Agregar» sigue su camino normal. */
  window.addEventListener('click', function(e){
    var c = e.target.closest && e.target.closest('#ccx .cc-ace');
    if(!c || e.target.closest('.add')) return;
    var h = c.getAttribute('data-h'); if(!h) return;
    e.preventDefault(); e.stopImmediatePropagation();
    location.href = '/products/' + h;
  }, true);
  window.addEventListener('keydown', function(e){
    if(e.key !== 'Enter') return;
    var c = e.target.closest && e.target.closest('#ccx .cc-ace');
    if(!c || e.target.closest('.add')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    location.href = '/products/' + c.getAttribute('data-h');
  }, true);

  /* ------------------------------------------------------------- pintar */
  function pintar(){
    if(pintado) return;
    DAT = json('cc-datos'); if(!DAT) return;
    (DAT.preventa || []).forEach(function(sk){ PRE[sk] = 1; });
    if(!agrupar()) return;

    var total = CASAS.reduce(function(a, c){ return a + c.lista.length; }, 0);
    hueco.innerHTML =
      '<div class="cc-casas" id="ccCasas">' + CASAS.map(seccion).join('') + '</div>' +
      '<p class="cc-nada" id="ccNada" hidden>Ninguna casa ni fragancia con ese nombre.</p>';

    /* La barra y el riel NO pueden vivir dentro de #ccx: la sección del catálogo
       arrastra un `transform` de su animación de entrada, y un ancestro con transform
       se vuelve el bloque contenedor de sus hijos `position:fixed`. Dentro, quedaban
       fijos al principio de una sección de 65,000 px —o sea, invisibles—. Colgados del
       cuerpo vuelven a estar fijos a la pantalla. */
    var fijos = document.getElementById('ccFijos');
    if(!fijos){
      fijos = document.createElement('div');
      fijos.id = 'ccFijos'; fijos.className = 'cc-fijos';
      document.body.appendChild(fijos);
    }
    if(!fijos.querySelector("#ccBarra")) fijos.innerHTML =
      '<div class="cc-barra" id="ccBarra">' +
        '<div class="cc-caja">' +
          '<span class="cc-lupa" aria-hidden="true">&#9906;</span>' +
          '<input id="ccQ" type="search" autocomplete="off" role="combobox" aria-expanded="false" aria-controls="ccLista"' +
          ' placeholder="Diseñador, versión V618, fragancia o nota…" aria-label="Buscar en el catálogo">' +
          '<button class="cc-x" type="button" id="ccX" aria-label="Limpiar la búsqueda">&times;</button>' +
          '<b id="ccN"></b>' +
        '</div>' +
        '<div class="cc-filtros" id="ccFiltros">' +
          '<div class="cc-grupo" role="group" aria-label="Tipo de producto">' +
            '<button type="button" class="on" data-tipo="" aria-pressed="true">Todo</button>' +
            '<button type="button" data-tipo="perf" aria-pressed="false">Perfumes</button>' +
            '<button type="button" data-tipo="amb" aria-pressed="false">Aromatizantes</button>' +
            '<button type="button" data-tipo="ace" aria-pressed="false">Aceites para difusor</button>' +
          '</div>' +
          '<i class="cc-sep" aria-hidden="true"></i>' +
          '<div class="cc-grupo" role="group" aria-label="Para quién">' +
            '<button type="button" data-para="ella" aria-pressed="false">Para ella</button>' +
            '<button type="button" data-para="el" aria-pressed="false">Para él</button>' +
            '<button type="button" data-para="uni" aria-pressed="false">Unisex</button>' +
          '</div>' +
        '</div>' +
        '<div class="cc-lista" id="ccLista" role="listbox"></div>' +
      '</div>' +
      '<nav class="cc-az" id="ccAz" aria-label="Índice de diseñadores por letra"></nav>' +
      '<div class="cc-globo" id="ccGlobo" aria-hidden="true"></div>';

    vivas(); indice(); buscar(); barraViva();
    document.getElementById('ccN').textContent = CASAS.length + ' casas · ' + total + ' productos';
    pintado = true;
  }

  function seccion(c){
    var partes = c.casa.split(' ');
    var titulo = partes.length > 1
      ? esc(partes.slice(0, -1).join(' ')) + ' <em>' + esc(partes[partes.length-1]) + '</em>'
      : '<em>' + esc(c.casa) + '</em>';
    var cuenta = cuentaDe(c.lista);
    var hayMas = c.lista.length > ASOMO;
    /* Las colecciones no son una marca: su pie habla de hoteles y tiendas. */
    var pie = c.ide.coleccion
      ? 'Velantis no está asociada con los hoteles ni con las tiendas que se mencionan, ni guarda relación ' +
        'comercial con ellos. Sus nombres se usan únicamente como referencia olfativa.'
      : 'Velantis no está asociada con ' + esc(c.casa) + ' ni guarda relación ' +
        'comercial con esa firma. Su marca se menciona únicamente como referencia olfativa; ' +
        'Velantis elabora perfumes de inspiración.';
    /* La tira se llena cuando la casa se acerca. Construir las 436 tarjetas de golpe
       dejaba 15,000 nodos en el DOM y tres segundos de tareas largas al arrancar. */
    return '<section class="cc-casa ' + c.ide.clave + ' a-' + c.ide.aire + ' t-' + c.ide.trama + '"' +
      ' id="' + c.ide.id + '" data-letra="' + esc(c.ide.letra) + '" data-casa="' + esc(suave(c.casa)) + '"' +
      ' style="--t:' + c.ide.tinta + ';--c:' + c.color + ';--l:' + c.ide.contra + '">' +
      '<div class="cc-fondo"><span class="cc-color"></span><span class="cc-trama"></span><span class="cc-luz"></span></div>' +
      '<div class="cc-dentro">' +
        '<div class="cc-cab"><div class="cc-origen">' + esc(c.ide.origen) + '</div>' +
          '<h2>' + titulo + '</h2>' +
          '<p class="cc-linea">' + esc(c.ide.linea) + '</p>' +
          '<div class="cc-mandos"><span class="cc-cuantas">' + cuenta + '</span>' +
          (window.VELANTIS_CASAS_COLECCIONES[c.casa]?'<a class="cc-shopify-link" href="'+esc(window.VELANTIS_CASAS_COLECCIONES[c.casa].url)+'">Ver colección &rarr;</a>':'') +
          '<button class="cc-ver" type="button" data-ver' + (hayMas ? '' : ' hidden') + '>Ver colección completa <s>&#9662;</s></button>' +
          '</div></div>' +
        '<div class="cc-tira" data-lleno="0"></div>' +
        '<div class="cc-rejilla" data-lleno="0"></div>' +
      '</div>' +
      '<p class="cc-pie">' + pie + '</p>' +
      '</section>';
  }

  /* --------------------------------------------- ver colección completa
     La rejilla se llena la primera vez que se abre, no antes: son 562 tarjetas y
     cada una es un lienzo del motor en cuanto entra a la vista. */
  document.addEventListener('click', function(e){
    var b = e.target.closest('#ccx [data-ver]'); if(!b) return;
    var sec = b.closest('.cc-casa'), rej = sec.querySelector('.cc-rejilla');
    var c = CASAS.filter(function(x){ return x.ide.id === sec.id; })[0];
    var abre = !sec.classList.contains('abierta');
    if(abre && rej.getAttribute('data-lleno') === '0'){
      rej.innerHTML = listaDe(c).map(function(x){ return tarjeta(x, c.casa, c.ide.femenino, c.soloElla); }).join('');
      rej.setAttribute('data-lleno', '1');
    }
    sec.classList.toggle('abierta', abre);
    b.childNodes[0].nodeValue = abre ? 'Ver menos ' : 'Ver colección completa ';
    if(abre){ if(!b.hasAttribute('data-inline-more')) irA(sec); despertarMotor(); }
    else if(b.hasAttribute('data-inline-more')) sec.scrollIntoView({block:'start',behavior:'instant'});
    esconder(true);
  }, true);

  /* Solo anima la casa que se está viendo. Ver la nota en la hoja: 83 fondos animados
     a la vez, con un desenfoque de 46 px cada uno, arrastraban la página entera. */
  /* Saltar a una sección, a prueba de que la página crezca debajo.
     El salto suave iba en camino mientras el filtro se limpiaba —83 casas vuelven a
     aparecer— y mientras las tiras se llenaban al pasar. El destino se movía decenas de
     miles de píxeles y el scroll terminaba en el pie de página. Se salta en seco y se
     corrige dos veces, cuando el acomodo ya se asentó. */
  /* El tema trae `html{scroll-behavior:smooth}` en assets/index-todo.css, asi que el
     salto que este modulo creia dar EN SECO venia animado. Con el catalogo cambiando de
     alto de 73.000 a 9.000 px en cada tecla, esa animacion se queda a medio camino y se
     recalcula contra un documento que ya no existe: medido, catorce tirones y 25.801 px
     de recorrido para llegar a un sitio que estaba a 13.951 —eso era «se vuelve loco»—.
     Con el salto instantaneo: un movimiento y un residuo de veinte pixeles.
     El estilo en linea gana sobre la hoja del tema durante la llamada y se devuelve
     enseguida, porque sin animacion scrollIntoView es sincrono. */
  function saltar(el, block){
    if(!el) return;
    var h = document.documentElement, antes = h.style.scrollBehavior;
    h.style.scrollBehavior = 'auto';
    el.scrollIntoView({block: block || 'start', behavior: 'instant'});
    h.style.scrollBehavior = antes;
  }

  function irA(sec, block){
    if(!sec) return;
    var b = block || 'start';
    saltar(sec, b);
    setTimeout(function(){ saltar(sec, b); }, 260);
    setTimeout(function(){ saltar(sec, b); }, 900);
  }

  /* Las notas se abren. Al llegar a una casa desde el buscador, sus fichas arrancan con
     la escena recogida contra el frasco; un par de segundos después la abren, una sola
     vez, y se quedan abiertas. Es el mismo gesto que hace la ficha del centro en el
     carrusel de preventa, aquí usado para decir «llegaste, aquí está». */
  var relojNotas = [], secAnimando = null;
  function abrirNotas(sec){
    if(!sec) return;
    relojNotas.forEach(clearTimeout); relojNotas = [];
    if(secAnimando && secAnimando !== sec) secAnimando.classList.remove('cc-anima');
    secAnimando = sec;
    /* La tira se llena sola cuando la casa se acerca, y al llegar desde el buscador eso
       pasaba DESPUES de marcar las notas: el `innerHTML` de la tira reemplazaba las
       fichas recien marcadas por unas nuevas, ya abiertas, y no se veia animacion
       ninguna. Se llena aqui, antes de marcar, y `llenarTira` respeta el estado. */
    llenarTira(sec);
    var v = sec.querySelectorAll('.cat-card');
    if(!v.length) return;
    /* El recorte solo vive mientras esta casa anima; ver la nota de la hoja. */
    sec.classList.add('cc-anima');
    Array.prototype.forEach.call(v, function(c){ c.classList.add('cc-cerrada'); });
    /* Un cuadro para que el navegador registre el estado cerrado ANTES de quitarlo: si
       se agrega y se quita dentro del mismo ciclo de estilo, no hay dos valores que
       interpolar y la transicion no arranca. */
    var ultimo = 1800 + Math.min(v.length - 1, 12) * 70;
    requestAnimationFrame(function(){
      var image = v[0].querySelector('.cat-img,.rl-static-photo');
      if(image) getComputedStyle(image).clipPath;
      Array.prototype.forEach.call(v, function(c, i){
        relojNotas.push(setTimeout(function(){ c.classList.remove('cc-cerrada'); },
                                   1800 + Math.min(i, 12) * 70));
      });
    });
    /* Terminada la cascada se retira el recorte: `inset(0)` y `none` se ven igual y asi
       las fichas dejan de componerse una por una. */
    relojNotas.push(setTimeout(function(){
      sec.classList.remove('cc-anima');
      if(secAnimando === sec) secAnimando = null;
    }, ultimo + 1400));
  }

  function llenarTira(sec){
    var t = sec.querySelector('.cc-tira');
    if(!t || t.getAttribute('data-lleno') === '1') return;
    var c = CASAS.filter(function(x){ return x.ide.id === sec.id; })[0];
    if(!c) return;
    t.innerHTML = listaDe(c).slice(0, ASOMO).map(function(x){
      return tarjeta(x, c.casa, c.ide.femenino, c.soloElla); }).join('');
    t.setAttribute('data-lleno', '1');
    /* Si esta casa esta en plena apertura de notas, las fichas nuevas nacen cerradas. */
    if(sec.classList.contains('cc-anima'))
      Array.prototype.forEach.call(t.querySelectorAll('.cat-card'), function(c2){
        c2.classList.add('cc-cerrada'); });
  }

  function vivas(){
    var secs = document.querySelectorAll('#ccCasas .cc-casa');
    if(!('IntersectionObserver' in window)){
      Array.prototype.forEach.call(secs, function(s){ s.classList.add('viva'); llenarTira(s); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        e.target.classList.toggle('viva', e.isIntersecting);
        if(!e.isIntersecting) return;
        llenarTira(e.target);
        /* si quedo una busqueda pendiente para esta casa, se resuelve al llegar */
        if(e.target.__filtro && window.__ccAplicar) window.__ccAplicar(e.target);
      });
    }, {rootMargin:'300px 0px'});
    Array.prototype.forEach.call(secs, function(s){ io.observe(s); });
  }

  /* -------------------------------------------------------- el índice A-Z */
  var marcarLetra = function(){};
  function indice(){
    var az = document.getElementById('ccAz'), globo = document.getElementById('ccGlobo');
    var LETRAS = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    var hay = {}; CASAS.forEach(function(c){ hay[c.ide.letra] = true; });
    az.innerHTML = LETRAS.map(function(L){
      return '<button type="button" data-l="' + L + '"' + (hay[L] ? ' class="hay"' : ' disabled') + '>' + L + '</button>';
    }).join('');
    var secs = [].slice.call(document.querySelectorAll('#ccCasas .cc-casa'));
    marcarLetra = function(L){
      Array.prototype.forEach.call(az.children, function(b){ b.classList.toggle('on', b.getAttribute('data-l') === L); });
    };
    function irLetra(L){
      var s = secs.filter(function(x){ return !x.hidden && x.dataset.letra === L; })[0];
      if(!s){
        var i = LETRAS.indexOf(L);
        for(var k = i + 1; k < LETRAS.length && !s; k++)
          s = secs.filter(function(x){ return !x.hidden && x.dataset.letra === LETRAS[k]; })[0];
      }
      if(s){ irA(s); marcarLetra(s.dataset.letra); }
    }
    az.addEventListener('click', function(e){
      var b = e.target.closest('button'); if(!b || b.disabled) return; irLetra(b.getAttribute('data-l'));
    });
    function letraEn(y){
      var r = null;
      Array.prototype.forEach.call(az.children, function(b){
        var q = b.getBoundingClientRect(); if(y >= q.top && y <= q.bottom) r = b; });
      return r;
    }
    function recorrer(e){
      var b = letraEn(e.clientY); if(!b || b.disabled) return;
      globo.textContent = b.getAttribute('data-l'); globo.style.top = e.clientY + 'px';
      irLetra(b.getAttribute('data-l'));
    }
    az.addEventListener('pointerdown', function(e){
      if(e.target.disabled) return;
      az.classList.add('tocando');
      try{ az.setPointerCapture(e.pointerId); }catch(err){}
      recorrer(e);
    });
    az.addEventListener('pointermove', function(e){ if(az.classList.contains('tocando')) recorrer(e); });
    function soltar(){ az.classList.remove('tocando'); }
    az.addEventListener('pointerup', soltar); az.addEventListener('pointercancel', soltar);
    /* La letra se calcula, no se observa. Con un observador y una banda estrecha, un
       salto instantáneo la cruza sin disparar nada y el índice se quedaba en la A. */
    window.__ccLetraAqui = function(){
      var medio = window.innerHeight * 0.4, mejor = null;
      for(var i = 0; i < secs.length; i++){
        if(secs[i].hidden) continue;
        if(secs[i].getBoundingClientRect().top <= medio) mejor = secs[i]; else break;
      }
      if(!mejor) mejor = secs.filter(function(x){ return !x.hidden; })[0];
      if(mejor) marcarLetra(mejor.dataset.letra);
    };
    window.__ccLetraAqui();
    window.__ccIr = irLetra;
  }

  /* --------------------------------------------------------- el buscador */
  /* Los nombres de siempre siguen valiendo para buscar: la casa se llama hoy «Rabanne»,
     pero quien escribe «paco rabanne» tiene que encontrarla igual (la casa, 16-sep). */
  function tambien(casa){ return ((DAT.busca || {})[casa] || []).join(' '); }

  function buscar(){
    var q = document.getElementById('ccQ'), lista = document.getElementById('ccLista');
    var barra = document.getElementById('ccBarra'), nada = document.getElementById('ccNada');
    var cuenta = document.getElementById('ccN');
    var secs = [].slice.call(document.querySelectorAll('#ccCasas .cc-casa'));
    var INDICE = [];
    CASAS.forEach(function(c){
      c.lista.forEach(function(x){
        var tipo = x.ace ? ' aceite difusor' : (x.amb ? ' aromatizante ambiental ' + x.ref : '');
        INDICE.push({x:x, i:x.i, sku:x.r[12] || '', nom:x.r[0], casa:c.casa, id:c.ide.id, color:c.color,
          b: suave((x.r[12] || '') + ' ' + x.r[0] + ' ' + c.casa + ' ' + tambien(c.casa) + ' ' +
                   (x.r[3] || '') + ' ' + notas(x.r) + tipo + ' ' + (x.r[1] === 'Dama' ? 'dama mujer ella femenino' : x.r[1] === 'Caballero' ? 'caballero hombre el masculino' : 'unisex ambos'))});
      });
    });
    var props = [], sel = -1, FOTOS = {}, FOTOS_NORM = {};
    function fotoDe(nombre){ return FOTOS[nombre] || FOTOS[String(nombre).toUpperCase()] || FOTOS_NORM[plano(nombre)] || ''; }
    function lookupCollection(n){return ((window.VELANTIS_CASAS_COLECCIONES||{})[n]||{}).url||'';}
    function identidadPropuesta(x){
      var c = CASAS.filter(function(c){return c.ide.id===x.id;})[0];
      return c ? ' cc-branded-result '+c.ide.clave+' a-'+c.ide.aire+' t-'+c.ide.trama : '';
    }
    function estiloPropuesta(x){
      var c = CASAS.filter(function(c){return c.ide.id===x.id;})[0];
      return c ? '--t:'+c.ide.tinta+';--c:'+c.color+';--l:'+c.ide.contra : '--c:'+x.color;
    }
    function fotoPropuesta(x){
      var nombres = x.tipo === 'casa' ? (x.muestras || []) : [x.nom];
      var fotos = nombres.map(function(n){ return {nombre:n, url:fotoDe(n)}; }).filter(function(f){ return !!f.url; });
      return '<span class="cc-result-media'+(x.tipo === 'casa'?' cc-result-house':'')+'" aria-hidden="true">'+
        (fotos.length ? fotos.map(function(f){ return '<img src="'+esc(f.url)+'" alt="" loading="lazy" decoding="async">'; }).join('') : '<span class="cc-result-placeholder">'+(x.tipo === 'casa'?'Casa':'V')+'</span>')+'</span>';
    }
    var fotosUrl = (window.VELANTIS_CARRITO_CFG || {}).fotos;
    if(fotosUrl) (window.VELANTIS_FOTOS_PROMISE||fetch(fotosUrl).then(function(r){ if(!r.ok) throw Error('Fotos no disponibles'); return r.json(); })).then(function(data){
      FOTOS = data || {}; Object.keys(FOTOS).forEach(function(n){ FOTOS_NORM[plano(n)] = FOTOS[n]; });
      if(barra.classList.contains('abierta')) proponer();
    }).catch(function(){ /* La búsqueda sigue funcionando si una foto no carga. */ });

    var caja=q.closest('.cc-caja'), filtros=document.getElementById('ccFiltros');
    if(filtros)barra.insertBefore(filtros,caja);
    caja.appendChild(lista); barra.dataset.ccDropdown='52';
    function posicionarLista(){
      if(!barra.classList.contains('abierta'))return;
      var r=caja.getBoundingClientRect(), vv=window.visualViewport;
      var top=vv?vv.offsetTop:0, bottom=top+(vv?vv.height:innerHeight);
      var band=document.getElementById('promoStrip');
      if(band){var br=band.getBoundingClientRect();if(br.bottom>top&&br.top<bottom)top=Math.max(top,br.bottom);}
      var abajo=Math.max(0,bottom-r.bottom-12), arriba=Math.max(0,r.top-top-12);
      var up=abajo<Math.min(320,lista.scrollHeight)&&arriba>abajo;
      barra.dataset.ccDirection=up?'up':'down';
      lista.style.setProperty('--cc-list-height',Math.min(520,Math.max(0,up?arriba:abajo))+'px');
    }
    var ccFrame=0;
    function agendaLista(){if(ccFrame)return;ccFrame=requestAnimationFrame(function(){ccFrame=0;posicionarLista();});}
    window.addEventListener('resize',agendaLista,{passive:true});
    window.addEventListener('scroll',agendaLista,{passive:true,capture:true});
    if(window.visualViewport){visualViewport.addEventListener('resize',agendaLista,{passive:true});visualViewport.addEventListener('scroll',agendaLista,{passive:true});}
    new ResizeObserver(agendaLista).observe(caja);
    new MutationObserver(function(){if(!barra.classList.contains('abierta')){q.setAttribute('aria-expanded','false');q.removeAttribute('aria-activedescendant');}}).observe(barra,{attributes:true,attributeFilter:['class']});

    function puntuacion(x,t){return VelantisBusqueda.coincidencia(t,{sku:x.sku,nombre:x.nom,casa:x.casa,texto:x.b});}
    function proponer(){
      var t = suave(q.value.trim());
      barra.classList.toggle('con-texto', !!t);
      if(t.length < 2){ barra.classList.remove('abierta'); q.setAttribute('aria-expanded','false'); props = []; return; }
      var casas = CASAS.filter(function(c){
          return VelantisBusqueda.coincidencia(t,{nombre:c.casa,texto:c.casa+' '+tambien(c.casa)})>0 && listaDe(c).length; })
        .slice(0, 3).map(function(c){ return {tipo:'casa', casa:c.casa, id:c.ide.id, color:c.color, n:listaDe(c).length, muestras:listaDe(c).slice(0,3).map(function(x){return x.r[0];})}; });
      var piezas = INDICE.filter(function(x){ return puntuacion(x,t)>0 && pasa(x.x); }).sort(function(a,b){return puntuacion(b,t)-puntuacion(a,t);})
        .slice(0, 10 - casas.length).map(function(x){
          return {tipo:'pieza', sku:x.sku, nom:x.nom, casa:x.casa, id:x.id, color:x.color}; });
      /* Mantener el orden DOM, los índices y las flechas del teclado alineados. */
      casas.sort(function(a,b){return VelantisBusqueda.coincidencia(t,{nombre:b.casa})-VelantisBusqueda.coincidencia(t,{nombre:a.casa});});
      props = casas.concat(piezas); sel = -1;
      function grupo(items, offset, label){
        if(!items.length)return '';
        return '<div class="cc-result-group" role="group" aria-label="'+label+'"><div class="cc-result-label" aria-hidden="true">'+label+'</div><div class="cc-result-grid" role="presentation">'+items.map(function(x, j){ var i=offset+j;
            return '<button class="cc-fila'+identidadPropuesta(x)+'" type="button" data-result-type="'+x.tipo+'" id="ccO'+i+'" aria-selected="false" data-collection-url="'+esc(x.tipo==='casa'&&lookupCollection(x.casa)||'')+'" data-i="' + i + '" role="option" style="'+estiloPropuesta(x)+'">' +
              '<span class="cc-result-bg" aria-hidden="true"><span class="cc-result-color"></span><span class="cc-result-pattern"></span></span>' +
              fotoPropuesta(x) + '<span class="cc-result-copy"><small class="cod">' + (x.tipo === 'casa' ? 'CASA' : esc(x.sku)) + '</small>' +
              '<strong class="nm">' + esc(x.tipo === 'casa' ? x.casa : x.nom) + '</strong>' +
              '<small class="cs">' + esc(x.tipo === 'casa' ? (x.n + (x.n === 1 ? ' producto' : ' productos')) : x.casa) + '</small></span></button>';
          }).join('')+'</div></div>';
      }
      lista.innerHTML = props.length
        ? grupo(casas,0,'Casas de inspiración')+grupo(piezas,casas.length,'Fragancias y productos')+'<button class="cc-todos" type="button" data-todos="1">Ver todos los resultados en la página &rarr;</button>'
        : '<div class="cc-vacio">Nada con «'+esc(q.value.trim())+'». Prueba con el diseñador, el código V o el nombre original.</div>';
      barra.classList.add('abierta'); q.setAttribute('aria-expanded','true'); q.removeAttribute('aria-activedescendant'); requestAnimationFrame(posicionarLista);
    }

    /* Al filtrar, la página cambia de alto en grande: de 73,000 px a unos pocos miles, y
       otra vez con cada letra, y otra vez cuando las tiras se llenan al pasar. Cualquier
       intento de conservar la posición termina en un salto distinto por tecla —eso era el
       «se vuelve loco»— y a veces en el pie.
       La regla, entonces, es una sola: al EMPEZAR a buscar se sube al principio del
       catálogo, una vez. De ahí en adelante la vista no se toca, pase lo que pase con el
       alto, porque el principio del catálogo no se mueve: lo que hay encima no cambia. */
    var buscando = false;
    function alTopeDelCatalogo(){
      if(document.body.classList.contains('rl-home')) return;
      var c = document.getElementById('catalogo');
      saltar(c, 'start');
    }

    var porId = {};
    CASAS.forEach(function(c){ porId[c.ide.id] = c; });

    function llenarRejilla(sec, c){
      var rej = sec.querySelector('.cc-rejilla');
      if(!rej || rej.getAttribute('data-lleno') === '1') return rej;
      rej.innerHTML = listaDe(c).map(function(x){
        return tarjeta(x, c.casa, c.ide.femenino, c.soloElla); }).join('');
      rej.setAttribute('data-lleno', '1');
      return rej;
    }
    /* Abre la rejilla de una casa y esconde lo que no casa. Se llama al filtrar para las
       primeras casas, y mas tarde para las que se van acercando. */
    function aplicarFiltro(sec){
      var e = sec.__filtro;
      if(!e) return;
      llenarRejilla(sec, porId[sec.id]);
      var v = sec.querySelectorAll('.cat-card');
      for(var k = 0; k < v.length; k++)
        v[k].hidden = !e.filas[v[k].getAttribute('data-i')];
      sec.__filtro = null;
    }

    function vaciarRejilla(sec){
      var rej = sec.querySelector('.cc-rejilla');
      if(!rej || rej.getAttribute('data-lleno') === '0') return;
      rej.innerHTML = '';
      rej.setAttribute('data-lleno', '0');
    }

    /* Esta funcion construia el DOM para poder filtrarlo: por cada casa que no casaba
       por nombre, armaba SU REJILLA COMPLETA solo para leerla. Medido: la primera tecla
       tardaba 1,338 ms y creaba 391 fichas; al terminar de escribir «tom ford» habia 549
       fichas y 17,205 nodos —el triple de la pagina— para ensenar UNA fragancia. Y al
       borrar no se limpiaba nada.
       Ahora se resuelve contra `INDICE`, que ya vive en memoria, y solo se construyen las
       rejillas de las casas que de verdad tienen coincidencias. */
    function filtrar(){
      var t = suave(q.value.trim());
      /* Con una sola letra casan casi todas las casas y el filtro no sirve de nada; lo
         unico que hace es trabajo. Medido: «t» tardaba 1.6 s. La lista de propuestas ya
         usaba este mismo minimo de dos caracteres. */
      if(t.length < 2) t = '';
      if(t && !buscando){ buscando = true; alTopeDelCatalogo(); }
      else if(!t) buscando = false;

      if(!t){
        var vis = 0, prods = 0;
        secs.forEach(function(s){
          var ls = listaDe(porId[s.id]);
          s.hidden = !ls.length;
          if(ls.length){ vis++; prods += ls.length; }
          /* se devuelve el DOM a su tamano: las rejillas que abrio la busqueda se vacian,
             menos las que el visitante abrio a proposito con «Ver coleccion completa» */
          /* se distingue lo que abrio la busqueda de lo que abrio el visitante: solo
             se recoge lo primero, para que el DOM no quede inflado tras buscar */
          s.__filtro = null;
          if(s.classList.contains('cc-porbusqueda')){
            s.classList.remove('abierta', 'cc-porbusqueda');
            vaciarRejilla(s);
            var b = s.querySelector('[data-ver]');
            if(b) b.childNodes[0].nodeValue = 'Ver colección completa ';
          }
          var v = s.querySelectorAll('.cat-card');
          for(var k = 0; k < v.length; k++) v[k].hidden = false;
          if(s.classList.contains('viva')) llenarTira(s);
        });
        cuenta.textContent = vis + (vis === 1 ? ' casa · ' : ' casas · ') + prods + (prods === 1 ? ' producto' : ' productos');
        nada.hidden = vis > 0;
        return;
      }

      /* 1. quien casa, resuelto en memoria: ni una linea de DOM todavia */
      var casan = {}, piezas = 0, vistas = 0, abiertas = 0;
      CASAS.forEach(function(c){
        var nl = listaDe(c).length;
        if(nl && VelantisBusqueda.puntuar(VelantisBusqueda.normalizar(t),c.casa)>0) casan[c.ide.id] = {todo:true, filas:null, n:nl};
      });
      for(var j = 0; j < INDICE.length; j++){
        var x = INDICE[j];
        if(puntuacion(x,t)<=0 || !pasa(x.x)) continue;
        var e = casan[x.id];
        if(!e){ e = casan[x.id] = {todo:false, filas:{}, n:0}; }
        if(e.todo) continue;
        if(!e.filas[x.i]){ e.filas[x.i] = 1; e.n++; }
      }

      /* Si la busqueda apunta a dos o tres casas, se abren enteras: son pocas fichas y
         es lo que uno espera al escribir «dior». Si apunta a muchas, se quedan cerradas
         y cada una se abre con su boton: expandir sesenta casas era el otro pico. */
      var cuantas = 0;
      for(var z in casan) if(casan.hasOwnProperty(z)) cuantas++;
      var pocas = cuantas <= 3;

      /* 2. y ahora si el DOM, solo de las casas implicadas */
      secs.forEach(function(s){
        var e = casan[s.id];
        if(!e){ s.hidden = true; return; }
        var c = porId[s.id];
        s.hidden = false; vistas++; piezas += e.n;
        /* Si casa por NOMBRE basta con ensenar la casa: su tira ya esta puesta y el
           visitante expande con «Ver coleccion completa». Expandirla aqui era construir
           cientos de fichas que nadie pidio. Solo se expande cuando la coincidencia esta
           DENTRO, en una pieza concreta, porque si no, no habria como ensenarla. */
        if(e.todo){
          s.__filtro = null;
          if(pocas){
            llenarRejilla(s, c);
            s.classList.add('abierta', 'cc-porbusqueda');
            var b2 = s.querySelector('[data-ver]');
            if(b2) b2.childNodes[0].nodeValue = 'Ver menos ';
          }else if(s.classList.contains('viva')) llenarTira(s);
          var w = s.querySelectorAll('.cat-card');
          for(var k = 0; k < w.length; k++) w[k].hidden = false;
          return;
        }
        /* La coincidencia esta DENTRO de la casa, asi que hay que abrir su rejilla. Pero
           «to» casa en las notas de medio catalogo —tonka, toronja, tomillo— y abrirlas
           todas de golpe costaba 880 ms y 465 fichas. Se abren las primeras, que son las
           que se van a ver, y las demas esperan a que uno se acerque, igual que las
           tiras. */
        s.classList.add('abierta', 'cc-porbusqueda');
        s.__filtro = e;
        /* Lo que YA esta en el DOM se filtra siempre y de inmediato: son las seis fichas
           de la tira, cuesta nada. Si no, la casa que queda en espera ensenaba su tira
           entera y salian fragancias que no casaban con lo buscado.
           Lo unico que se aplaza es CONSTRUIR la rejilla, que es lo caro. */
        var y = s.querySelectorAll('.cat-card');
        for(var m = 0; m < y.length; m++)
          y[m].hidden = !e.filas[y[m].getAttribute('data-i')];
        if(abiertas < 6 || s.querySelector('.cc-rejilla').getAttribute('data-lleno') === '1'){
          abiertas++;
          aplicarFiltro(s);
        }
      });

      cuenta.textContent = vistas + (vistas === 1 ? ' casa · ' : ' casas · ') +
        piezas + (piezas === 1 ? ' producto' : ' productos');
      nada.hidden = vistas > 0;
    }

    function llevarA(x){
      if(!x)return false;
      if(x.tipo==='pieza'&&window.VelantisProducto&&window.VelantisProducto.open){window.VelantisProducto.open(x.nom);return true;}
      var coleccion=(window.VELANTIS_CASAS_COLECCIONES||{})[x.casa];
      if(x.tipo==='casa'&&coleccion){location.assign(coleccion.url);return;}
      barra.classList.remove('abierta');
      /* Al elegir una propuesta el filtro se limpia: se eligió ir a un sitio, no
         quedarse con una sola tarjeta. La casa se abre entera y en color. */
      q.value = ''; barra.classList.remove('con-texto'); filtrar();
      var sec = document.getElementById(x.id); if(!sec) return;
      sec.hidden = false;
      var c = CASAS.filter(function(z){ return z.ide.id === x.id; })[0];
      if(x.tipo === 'casa'){
        var rc = sec.querySelector('.cc-rejilla');
        if(rc.getAttribute('data-lleno') === '0'){
          rc.innerHTML = listaDe(c).map(function(z){ return tarjeta(z, c.casa, c.ide.femenino, c.soloElla); }).join('');
          rc.setAttribute('data-lleno', '1');
        }
        sec.classList.add('abierta');
        var vc = sec.querySelector('[data-ver]'); if(vc) vc.childNodes[0].nodeValue = 'Ver menos ';
      }
      if(x.tipo === 'pieza'){
        var rej = sec.querySelector('.cc-rejilla');
        if(rej.getAttribute('data-lleno') === '0'){
          rej.innerHTML = listaDe(c).map(function(z){ return tarjeta(z, c.casa, c.ide.femenino, c.soloElla); }).join('');
          rej.setAttribute('data-lleno', '1');
        }
        sec.classList.add('abierta');
        var v = sec.querySelector('[data-ver]'); if(v) v.childNodes[0].nodeValue = 'Ver menos ';
      }
      despertarMotor();
      setTimeout(function(){ esconder(true); }, 240);
      if(x.tipo !== 'pieza'){ irA(sec); abrirNotas(sec); return; }
      /* En una fragancia el destino es la FICHA, no el encabezado. Antes se llamaba
         también a irA(sec), y su corrección de los 900 ms se comía el centrado de la
         ficha: llegabas a la casa pero la fragancia quedaba fuera de pantalla. */
      var f = sec.querySelector('.cc-rejilla .cat-card[data-sku="' + x.sku + '"]');
      if(!f){ irA(sec); return; }
      f.classList.add('cc-destacada');
      setTimeout(function(){ f.classList.remove('cc-destacada'); }, 3200);
      abrirNotas(sec);
      [0, 260, 700, 1200].forEach(function(t){
        setTimeout(function(){ saltar(f, 'center'); }, t);
      });
    }

    window.VELANTIS_CC.irCasa=function(nombre){var c=CASAS.filter(function(c){return suave(c.casa)===suave(String(nombre||'').trim());})[0];if(!c)return false;llevarA({tipo:'casa',casa:c.casa,id:c.ide.id,color:c.color});return true;};
    window.VELANTIS_CC.irMasCercana=function(){proponer();var x=props[sel>=0?sel:0];if(!x)return false;llevarA(x);return true;};
    window.VELANTIS_CC.irSugerencia=function(i){var x=props[i];if(!x)return false;llevarA(x);return true;};
    lista.addEventListener('click', function(e){
      if(e.target.closest('[data-todos]')){ barra.classList.remove('abierta'); filtrar(); alTopeDelCatalogo(); return; }
      var b = e.target.closest('.cc-fila'); if(b) llevarA(props[+b.getAttribute('data-i')]);
    });
    q.addEventListener('input', function(){ proponer(); filtrar(); });
    q.addEventListener('keydown', function(e){
      if(!barra.classList.contains('abierta')) return;
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        sel = Math.max(0, Math.min(props.length - 1, sel + (e.key === 'ArrowDown' ? 1 : -1)));
        Array.prototype.forEach.call(lista.querySelectorAll('.cc-fila'), function(f, i){ f.classList.toggle('sel', i === sel); f.setAttribute('aria-selected',String(i===sel)); if(i===sel)q.setAttribute('aria-activedescendant',f.id); });
        var v = lista.querySelector('.cc-fila.sel'); if(v) v.scrollIntoView({block:'nearest'});
      }else if(e.key === 'Enter'){
        e.preventDefault();
        if(props.length) llevarA(props[sel>=0?sel:0]); else { barra.classList.remove('abierta'); filtrar(); }
      }else if(e.key === 'Escape') barra.classList.remove('abierta');
    });
    document.getElementById('ccX').addEventListener('click', function(){
      q.value = ''; barra.classList.remove('abierta','con-texto'); filtrar();
      q.focus();
    });
    document.addEventListener('click', function(e){
      if(!barra.contains(e.target)) barra.classList.remove('abierta'); });
    window.__ccAplicar = aplicarFiltro;

    /* ---- los filtros Para y Tipo ----
       Cambiar un filtro rehace las fichas de cada casa (tira y rejilla) con lo que
       queda, esconde las casas vacias, ajusta la cuenta y el indice A-Z, y vuelve a
       pasar el buscador encima. Como con el buscador, el alto de la pagina cambia en
       grande, asi que se sube una vez al principio del catalogo. */
    var chips = document.getElementById('ccFiltros');
    function marcarChips(){
      Array.prototype.forEach.call(chips.querySelectorAll('button'), function(b){
        var on = b.hasAttribute('data-tipo') ? b.getAttribute('data-tipo') === FILTRO.tipo
                                             : b.getAttribute('data-para') === FILTRO.para;
        b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function rehacer(){
      secs.forEach(function(s){
        var c = porId[s.id], ls = listaDe(c);
        var tira = s.querySelector('.cc-tira');
        tira.innerHTML = ''; tira.setAttribute('data-lleno', '0');
        var rej = s.querySelector('.cc-rejilla');
        var abierta = s.classList.contains('abierta') && !s.classList.contains('cc-porbusqueda');
        rej.innerHTML = ''; rej.setAttribute('data-lleno', '0');
        s.__filtro = null;
        s.querySelector('.cc-cuantas').textContent = cuentaDe(ls);
        var ver = s.querySelector('[data-ver]');
        if(ver) ver.hidden = ls.length <= ASOMO;
        if(abierta && ls.length > ASOMO) llenarRejilla(s, c);
        else if(abierta){ s.classList.remove('abierta'); if(ver) ver.childNodes[0].nodeValue = 'Ver colección completa '; }
        if(s.classList.contains('viva')) llenarTira(s);
      });
      var hay = {};
      CASAS.forEach(function(c){ if(listaDe(c).length) hay[c.ide.letra] = true; });
      Array.prototype.forEach.call(document.querySelectorAll('#ccAz button'), function(b){
        var L = b.getAttribute('data-l'); b.disabled = !hay[L]; b.classList.toggle('hay', !!hay[L]);
      });
    }
    chips.addEventListener('click', function(e){
      var b = e.target.closest('button'); if(!b) return;
      if(b.hasAttribute('data-tipo')){
        FILTRO.tipo = b.getAttribute('data-tipo');
        /* un aromatizante o un aceite no tiene genero */
        if(FILTRO.tipo === 'amb' || FILTRO.tipo === 'ace') FILTRO.para = '';
      }else{
        var v = b.getAttribute('data-para');
        FILTRO.para = FILTRO.para === v ? '' : v;
        if(FILTRO.para && (FILTRO.tipo === 'amb' || FILTRO.tipo === 'ace')) FILTRO.tipo = 'perf';
      }
      marcarChips();
      rehacer();
      filtrar();
      if(q.value.trim().length >= 2) proponer();
      alTopeDelCatalogo();
      if(window.__ccLetraAqui) setTimeout(window.__ccLetraAqui, 60);
    });
    window.VELANTIS_CC_FILTRO = function(){ return {tipo:FILTRO.tipo, para:FILTRO.para}; };
    function aplicarRuta(){
      var ruta=location.hash.replace(/^#\//,'').replace(/\/$/,'');
      FILTRO.para=({dama:'ella',caballero:'el',unisex:'uni'})[ruta] || '';
      FILTRO.tipo=FILTRO.para||ruta==='disenadores'?'perf':ruta==='ambientales'?'amb':ruta==='aceites'?'ace':'';
      marcarChips(); rehacer(); filtrar();
    }
    window.addEventListener('hashchange',aplicarRuta);
    aplicarRuta();
    filtrar();
  }

  /* El motor dibuja las tarjetas nuevas por su cuenta y a su ritmo: unas cinco por
     segundo, medido. No se le apura a propósito. Se probó forzarlo —`__puente(n)` monta
     una a una— y meterle catorce escenas de golpe congela el teléfono; ese fue el error
     del 4 de septiembre y no se repite. Mientras llega el lienzo, la tarjeta clara ya
     enseña la foto de familia del sitio, así que nunca se ve un hueco gris. */
  function despertarMotor(){}

  /* ------------------------------------- la barra se esconde y vuelve */
  function esconder(v){
    var b = document.getElementById('ccBarra'), q = document.getElementById('ccQ');
    if(!b) return;
    if(v && (document.activeElement === q || b.classList.contains('abierta'))) return;
    b.classList.toggle('oculta', v);
  }
  function barraViva(){
    var b = document.getElementById('ccBarra'), az = document.getElementById('ccAz');
    var q = document.getElementById('ccQ'), sec = document.getElementById('catalogo');
    var y0 = window.scrollY, pedido = false;

    /* La barra NO se esconde al bajar. Se probó así y el resultado fue que nunca se
       veía: al catálogo se llega bajando, así que uno llegaba y la barra ya estaba
       fuera de cuadro. Se esconde solo cuando estorba de verdad —al abrir una colección
       o al saltar desde el buscador— y vuelve en cuanto se sube. */
    function medir(){
      pedido = false;
      var r = sec.getBoundingClientRect();
      var dentro = r.top < window.innerHeight * 0.92 && r.bottom > 120;
      b.classList.toggle('fuera', !dentro);
      az.classList.toggle('fuera', !dentro);
      var y = window.scrollY;
      if(y < y0 - 6) b.classList.remove('oculta');     /* subir: vuelve */
      y0 = y;
      if(dentro && window.__ccLetraAqui) window.__ccLetraAqui();
    }
    window.addEventListener('scroll', function(){
      if(pedido) return;
      pedido = true; requestAnimationFrame(medir);
    }, {passive:true});
    window.addEventListener('resize', function(){ requestAnimationFrame(medir); }, {passive:true});
    q.addEventListener('focus', function(){ b.classList.remove('oculta'); });
    medir();
  }

  /* ------------------------------------------------------------ arranque
     Se espera al mapa vivo para que los precios sean los de hoy, y a que el catálogo
     del sitio haya publicado window.VELANTIS_CAT. */
  function intentar(n){
    pintar();
    if(!pintado && n < 40) setTimeout(function(){ intentar(n + 1); }, 250);
  }
  var espera = (window.MAPA_VIVO && window.MAPA_VIVO.listo) || Promise.resolve();
  espera.then(function(){ intentar(0); });
  window.VELANTIS_CC = { pintar: pintar };
})();

 }
 if(!document.documentElement.classList.contains('vl-two-searches')||window.VelantisLegacyCatalogueStarted61){run();return;}
 var source=document.currentScript.src;
 function legacyRoute(){var route=(location.hash.match(/^#\/([^/?]+)/)||[])[1]||'';return ['','encuentra-tu-aroma','disenadores'].indexOf(route)<0;}
 function start(){if(!legacyRoute()||window.VelantisLegacyCatalogueStarted61)return;window.VelantisLegacyCatalogueStarted61=true;var script=document.createElement('script');script.src=source;document.body.appendChild(script);window.removeEventListener('hashchange',start);}
 window.addEventListener('hashchange',start);start();
})();
